module.exports = __webpack_public_path__ + "static/media/gmail_icon.efbbf2ad.png";